import { render, staticRenderFns } from "./recipe-cna-active.vue?vue&type=template&id=610099f2&scoped=true&"
import script from "./recipe-cna-active.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-active.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-active.vue?vue&type=style&index=0&id=610099f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610099f2",
  null
  
)

export default component.exports